import { Providers } from "../providers"
import { Toaster } from "@/components/ui/containers/toast"
import { SiteFooter } from "./site-footer"

import React from 'react';

export function BaseLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <a
        id="skip-link"
        href="#main"
        aria-label="Skip to main content"
        className="absolute -left-[999px] top-auto focus:left-4 focus:top-4 focus:translate-y-0 z-50 rounded px-3 py-2 bg-primary text-primary-foreground shadow-sm"
      >
        Skip to main content
      </a>

      <div vaul-drawer-wrapper="">
        <div className="relative flex min-h-[100dvh] max-h-[100dvh] w-full flex-col bg-background">
          <main id="main-content" tabIndex={-1} className="grid flex-grow">
            <span id="main" tabIndex={-1} className="sr-only" />
            <Providers>{children}</Providers>
          </main>

          <Toaster />
          <SiteFooter className="hidden md:block" />
        </div>
      </div>
    </>
  )
}
